import axios from 'axios'

import store from '@/stores'

import Servico from './Servico'

const URL = process.env.VUE_APP_API_URL

class AgendamentoServico extends Servico {
  constructor() {
    super('agenda')
  }

  adicionarAgendamento(data) {
    store.setCarregando()
    return axios
      .post(`${URL}/${this.path}/addAgendamento`, data)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  recuperarAgendamentos(filtros) {
    store.setCarregando()
    return axios
      .get(`${URL}/v2/${this.path}/`, {
        params: filtros,
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  recuperarAgendamento(id) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/agendamento/${id}`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  recuperarAgendamentoWithCID(id) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/agendamento/${id}?withCID=true`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  relatorioAtendimentoConvenio(filtro) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/relatorioAtendimentoConvenio`, {
        params: filtro,
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  relatorioAgendamentosDesativados(filtro) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/pesquisarAgendamentosDesativados`, {
        params: filtro,
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  adicionarDatasFaturamento(agendamentos) {
    store.setCarregando()
    return axios
      .put(`${URL}/${this.path}/adicionarDataFaturamento`, agendamentos)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  checarDisponibilidadeDataFaturamento(params) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/checarDisponibilidadeDataFaturamento/`, {
        params: params,
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  bloquearPagamento(agendamentoId) {
    store.setCarregando()
    return axios
      .put(`${URL}/${this.path}/${agendamentoId}/bloquearParaPagamento`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  desbloquearPagamento(agendamentoId) {
    store.setCarregando()
    return axios
      .put(`${URL}/${this.path}/${agendamentoId}/desbloquearParaPagamento`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  adicionarGuia(agendamentoId, guiaId) {
    store.setCarregando()
    return axios
      .put(`${URL}/${this.path}/${agendamentoId}/adicionarGuia/${guiaId}`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  removerGuia(agendamentoId, guiaId) {
    store.setCarregando()
    return axios
      .put(`${URL}/${this.path}/${agendamentoId}/removerGuia/${guiaId}`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  atualizarAgendamentoAssinado(agendamento) {
    store.setCarregando()
    return axios
      .put(
        `${URL}/${this.path}/${agendamento._id}/atualizarAssinado`,
        agendamento
      )
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  atualizarAgendamentoEvoluido(agendamento) {
    store.setCarregando()
    return axios
      .put(
        `${URL}/v2/agendamento/${agendamento._id}/atualizarEvoluido`,
        agendamento
      )
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  atualizarAgendamentoFaltouSemJustificativa(agendamento) {
    store.setCarregando()
    return axios
      .put(
        `${URL}/${this.path}/${agendamento._id}/atualizarFaltouSemJustificativa`,
        agendamento
      )
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  imprimirEtiqueta(data) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/agendamento/${data._id}/imprimir`, {
        responseType: 'blob',
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }
}

export default AgendamentoServico
